module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av712-8a7dfce8e4fb37b9cb98ac29ea0e0b54.jpg";